module.exports = "pegasus_template/assets/arc-logo.png";